function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.18 5.364A2.465 2.465 0 00.51 7.606c-.091 1.03.472 1.873 1.335 2.412.526.327.829.662.903 1.3l1.258.11c.613.054 1.153-.399 1.206-1.013l.209-2.38.01-.107A2.468 2.468 0 003.18 5.364zm8.152 14.48l18-9.309a1.563 1.563 0 01-.263 1.864c-.1.099-6.711 5.53-6.711 5.53l-8.823 6.372a2.463 2.463 0 01-1.648.699H8.94a.046.046 0 01-.007-.007 2.348 2.348 0 01-1.87-1.134L3.013 17.56l-.322-.477-.028-.04a.948.948 0 00-.022-.034l-.103-.153a3.09 3.09 0 012.184-4.67l2.085-.33 12.131-2.024c.106.544-.04 1.2-.782 1.542 0 0-6.421 2.072-10.125 3.299l.001.002-1.696.537v.314l1.973.104.634 2.183 1.456 1.863.137.168h.795z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "5",
  width: "30",
  height: "20"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.18 5.364A2.465 2.465 0 00.51 7.606c-.091 1.03.472 1.873 1.335 2.412.526.327.829.662.903 1.3l1.258.11c.613.054 1.153-.399 1.206-1.013l.209-2.38.01-.107A2.468 2.468 0 003.18 5.364zm8.152 14.48l18-9.309a1.563 1.563 0 01-.263 1.864c-.1.099-6.711 5.53-6.711 5.53l-8.823 6.372a2.463 2.463 0 01-1.648.699H8.94a.046.046 0 01-.007-.007 2.348 2.348 0 01-1.87-1.134L3.013 17.56l-.322-.477-.028-.04a.934.934 0 00-.022-.034l-.103-.153a3.09 3.09 0 012.184-4.67l2.085-.33 12.131-2.024c.106.544-.04 1.2-.782 1.542 0 0-6.421 2.072-10.125 3.299l.001.002-1.696.537v.314l1.973.104.634 2.183 1.456 1.863.137.168h.795z",
  fill: "currentColor"
}))));